import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ScriptReviewDetailPage } from "@/features/script-review/pages/ScriptReviewDetailPage";

export const Route = createFileRoute("/_authenticated/pre-flight-scripts/review/$reviewId")({
  component: ScriptReviewDetailRoute,
});

function ScriptReviewDetailRoute() {
  const { reviewId } = Route.useParams();
  const navigate = useNavigate();
  return (
    <ScriptReviewDetailPage
      reviewId={reviewId}
      onBack={() => void navigate({ to: "/pre-flight-scripts" })}
      onOpenVersion={(id) =>
        void navigate({ to: "/pre-flight-scripts/review/$reviewId", params: { reviewId: id } })
      }
    />
  );
}
